export default __webpack_public_path__ + "static/media/triangle.a4ecaa39.svg";